window.$ = window.jQuery = require('jquery')

/* File uplaod, ezt bootstrap előtt kell még mindenképp */
require('jquery-ui')
require('blueimp-file-upload')

require('bootstrap-sass')


// WEBPACK FOOTER //
// ./src/plugins/bootstrap.js